import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {
  ENDPOINT_CURRENT_MONTH, ENDPOINT_EXPORT,
  ENDPOINT_REPORTING,
  ENDPOINT_REPORTING_DISPENSES,
  ENDPOINT_REPORTING_DISPENSES_UTILISATEUR,
  ENDPOINT_REPORTING_MENSUELS,
  ENDPOINT_REPORTING_TRIMESTRIELS,
  ENDPOINT_SEARCH,
  ENDPOINT_SEARCH_UTILISATEURS
} from "../constants/endpoints";

let store = {
  debug: true,
  search(reporting, isMensuel) {
    const uri = isMensuel ? ENDPOINT_REPORTING_MENSUELS : ENDPOINT_REPORTING_TRIMESTRIELS;
    const url = `${ENDPOINT_REPORTING + uri}`;
    return axios.post(url, reporting);
  },
  export(reporting, isMensuel) {
    const uri = isMensuel ? ENDPOINT_REPORTING_MENSUELS : ENDPOINT_REPORTING_TRIMESTRIELS;
    const url = `${ENDPOINT_REPORTING + uri + ENDPOINT_EXPORT}`;
    return axios.post(url, reporting);
  },
  exportDispenses(reporting) {
    const url = `${ENDPOINT_REPORTING + ENDPOINT_REPORTING_DISPENSES + ENDPOINT_EXPORT}`;
    return axios
        .post(url, reporting);
  },
  searchDispenses(reporting) {
    const url = `${ENDPOINT_REPORTING + ENDPOINT_REPORTING_DISPENSES + ENDPOINT_SEARCH}`;
    return axios
        .post(url, reporting);
  },
  searchDispensesUtilisateur(reporting) {
    const url = `${ENDPOINT_REPORTING + ENDPOINT_REPORTING_DISPENSES + ENDPOINT_SEARCH_UTILISATEURS}`;
    return axios
        .post(url, reporting);
  },
  create(reporting, isUser) {
    const url = isUser ? `${ENDPOINT_REPORTING + ENDPOINT_REPORTING_DISPENSES_UTILISATEUR}` : `${ENDPOINT_REPORTING + ENDPOINT_REPORTING_DISPENSES}`;
    return axios
        .post(url, reporting)
        .then(() => {
          AlertStore.pushSuccess('Dispense créée avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  update(dispense) {
    return axios
        .put(ENDPOINT_REPORTING + ENDPOINT_REPORTING_DISPENSES, dispense)
        .then((value) => {
          AlertStore.pushSuccess("Dispense mise à jour avec succès.");
          return value.data;
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  delete(reporting) {
    return axios
        .delete(ENDPOINT_REPORTING + ENDPOINT_REPORTING_DISPENSES + '/' + reporting.id)
        .then(() => {
          AlertStore.pushSuccess('Dispense supprimée avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  getCurrentMonth() {
    return axios.get(ENDPOINT_REPORTING + ENDPOINT_CURRENT_MONTH)
        .then(response => {
          return response.data;
        })
        .catch(error => AlertStore.pushError(error.response.data.message));
  }
};

export default store;
